import customFetch from "../helpers/axios";

export async function getOrganization(organizationId) {
  if (!organizationId) {
    throw new Error("Missing organizationId for getOrganization");
  }
  const { data } = await customFetch.get(
    `/api/organizations/organization/${organizationId}/`
  );
  return data;
}

export async function updateOrganization(organizationId, payload) {
  if (!organizationId) {
    throw new Error("Missing organizationId for updateOrganization");
  }
  const { data } = await customFetch.patch(
    `/api/organizations/organization/${organizationId}/`,
    payload
  );
  return data;
}
